<template>
  <div class="vendor-trends-item-wrapper">
    <div class="dashboards-filters">
      <div class="dashboards-filters">
        <strong>{{ title }}</strong>
      </div>
      <div class="dashboards-filters dashboards-filters-date date-simple">
        <date-picker
          v-model="params.creation_date"
          format="D MMM"
          range-separator="-"
          :editable="false"
          :shortcuts="false"
          input-class="date-simple-input"
          range
          lang="en"
          class="dark"
        ></date-picker>
      </div>

      <div class="dashboards-filters">
        <type-switcher
          :options="reportTypeList"
          v-model="params.reportType"
          />
      </div>

      <div class="dashboards-filters">
        <language-picker
          :options="languagesList"
          v-model="params.sourceLanguage"
          placeholder="Source language"
        ></language-picker>
      </div>

      <div class="dashboards-filters">
        <language-picker
          :options="languagesList"
          v-model="params.targetLanguage"
          placeholder="Target language"
        ></language-picker>
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.industry_field"
          :options="industryFieldList"
          field-name="Name"
          placeholder="Industry sector(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.doc_type"
          :options="textCategoryList"
          field-name="Name"
          placeholder="Document type(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.qaModel"
          :options="qaModelsList"
          field-name="Name"
          placeholder="QA model(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.qaMethod"
          :options="qaMethodsList"
          field-name="Name"
          placeholder="Method(s)"
        />
      </div>
    </div>
    <template>
      <chart-constructor
      :options="chartOptions"
      />
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import props from './props';

export default Vue.extend({
  name: 'VendorTrendsMainItem',
  components: {
    'language-picker': () =>
      import('@/components/selectors/language/index.vue'),
    'filter-multiselect': () =>
      import('@/components/selectors/filterMultiple/index.vue'),
    'date-picker': () => import('vue2-datepicker'),
    'chart-constructor': () =>
      import('@/components/charts/chartConstructor/index.js'),
    'type-switcher': () => import('@/components/selectors/switcher/index.vue'),
  },
  props: {
    ...props,
  },
  data: () => ({
    chartOptions: Object(),
  }),
  watch: {
    value: {
      handler() {
        this.redrawGraph();
      },
      deep: true,
    },
  },
  computed: {
    params: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    genOptionsObject(series) {
      const categories = series.map((e) => e.name);
      return {
        chart: {
          type: 'bar',
          height: series.length * 50 + 60,
        },
        title: {
          text: '',
        },
        yAxis: {
          min: 0,
          max: 100,
          tickInterval: 10,
          opposite: true,
          title: {
            text: '',
          },
        },
        xAxis: {
          categories,
          tickInterval: 1,
          labels: {
            formatter: function() {
              return `<b>${this.value}</b>`;
            },
            style: {
              color: '#000000',
            },
          },
        },
        plotOptions: {
          bar: {
            stacking: undefined,
            dataLabels: {
              enabled: true,
              formatter: function() {
                return `<b>${this.point.y}</b> (${this.point.reports} reports)`;
              },
              align: 'left',
              verticalAlign: 'center',
              style: {
                color: '#000000',
              },
              y: -20,
            },
            grouping: false,
            pointWidth: 9,
            borderRadius: 5,
            pointPadding: 0,
            groupPadding: 0,
          },
        },
        tooltip: {
          formatter: function() {
            return `
            <b>${this.series.name}</b>
            <br>
            <b>QA Score:</b> ${this.point.qa.score}
            <br>
            QA Level: ${this.point.qa.level}
            <br>
            Total reports: ${this.point.reports}
            `;
          },
        },
        legend: {
          enabled: false,
        },
        series,
      };
    },
    redrawGraph() {
      this.getData().then((series) => {
        this.chartOptions = this.genOptionsObject(this.addSeriesData(series));
      });
    },
    // Impementing this methods in child components
    getData() {
      return new Promise((res) => {
        res(Array());
      });
    },
    addSeriesData(series) {
      return series.map((item) => {
        if (!item.data[0].hasOwnProperty('qa')) {
          return item;
        }
        item.color = item.data[0].qa.score === item.data[0].qa.level ? '#fbba00' : (
          item.data[0].qa.score > item.data[0].qa.level ? '#27a415' : '#ff0000'
        );
        return item;
      });
    },
  },
  mounted() {
    this.redrawGraph();
  },
});
</script>

<style lang="scss">
.vendor-trends-item-wrapper {
  margin-bottom: 50px;
}
.dashboards-filters {
  margin-bottom: 0!important;
  flex-flow: row wrap;
  height: auto;

  &-date {
    margin-left: 40px;
  }
}
</style>
